export enum ObjectModelRelationCapability {
  labelable = 1,
  inverseLabelable = 2,
  requireable = 3,
  inverseDependentDestroy = 4,
  accountRelationUserTypeable = 5,
  referenceable = 6,
  indexable = 7,
  portalClaimable = 8,
}
